import styled from "styled-components";

import Tip from "components/other/Tip";

const InputWithLabel = styled.div`
  width: ${(props) => props.width};
  margin-top: ${(props) => (props.margintop ? props.margintop : "0px")};

  display: flex;
  flex-direction: column;
`;

const LabelLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Label = styled.div`
  padding-left: 4px;

  display: flex;
  align-items: center;
  gap: 6px;
`;

const LabelText = styled.div`
  font-weight: 600;
`;

const InputWrap = styled.div`
  margin-top: 8px;

  display: flex;
  flex-direction: column;
`;

export default ({
  label,
  children,
  width,
  marginTop,
  tip,
  tipId,
  topRightContent,
  clickableTip,
}) => {
  return (
    <InputWithLabel width={width} margintop={marginTop}>
      <LabelLine>
        <Label>
          <LabelText>{label}</LabelText>
          {tip && <Tip tip={tip} tipId={tipId} clickable={clickableTip} />}
        </Label>
        {topRightContent}
      </LabelLine>
      <InputWrap>{children}</InputWrap>
    </InputWithLabel>
  );
};
